import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .patti-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 2;
      height: fit-content;
    }

    .image {
      grid-column: 2 / 8;
      grid-row: 3;
      height: fit-content;
    }

    .text {
      grid-column: 2 / 8;
      grid-row: 4;
      height: fit-content;
    }

    .image > img {
      display: block;
      width: 100%;
      margin-bottom: calc(16rem / var(--default-rem-px-count));
    }
    /* Statement text: h3 defaults (16/20 -> 24/30 at 600px). */
    h3 {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .patti-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      /* Top-row texts share a first baseline; the image column keeps its
         own top edge. */
      .description {
        grid-column: 2 / 6;
        grid-row: 2;
        align-self: baseline;
      }

      .image {
        grid-column: 6 / 10;
        grid-row: 2;
      }

      .text {
        grid-column: 10 / 14;
        grid-row: 2;
        align-self: baseline;
      }

      h3 {
        padding-top: 0;
      }
    }

    @media (min-width: 1024px) {
      .description {
        grid-column: 2 / 5;
      }
    }
  `,
];
